/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class DocumentService extends services.DataService<Wars.Domain.Model.Documents.DocumentConfiguration> {

        constructor(
            injectedBreeze: typeof breeze,
            $q: angular.IQService,
            private $http: angular.IHttpService,
            private systemLevelService: services.SystemLevelService) {
            super(injectedBreeze, $q);
        }

        public getDocumentConfiguration(id: string): ng.IPromise<Wars.Domain.Model.Documents.DocumentConfiguration> {
            const query = this.breezeModule.EntityQuery
                .from("DocumentConfigurations")
                .where("id", "==", id)
                .expand("canDownloadSecureDocumentSecurityMatrix, canSecureDocumentSecurityMatrix, myAvailableDocumentTypes.mySystemCode");

            return this.fetch(query);
        }

        public getDocumentConfigs(processConfigId: string): ng.IPromise<Wars.Domain.Model.Documents.DocumentConfiguration[]> {
            const query = this.breezeModule.EntityQuery
                .from("DocumentConfigurations")
                .where("processConfiguration_id", "==", processConfigId)
                .expand("canDownloadSecureDocumentSecurityMatrix, canSecureDocumentSecurityMatrix, myAvailableDocumentTypes.mySystemCode");

            return this.executeQuery(query);
        }

        public createDocumentConfig(): Wars.Domain.Model.Documents.DocumentConfiguration {
            var docConfig = this.createNewEntity<Wars.Domain.Model.Documents.DocumentConfiguration>("DocumentConfiguration");
            docConfig.uniqueIdentifier = UtilityService.generateGuidComb();
            docConfig.overrideSystemDocumentAccepts = false;
            docConfig.includeDocumentType = false;
            docConfig.includeDocumentComment = false;
            docConfig.includeDocumentDelete = false;
            docConfig.maxDocumentsAllowed = 1;
            docConfig.useSingleMetadataForMultipleFiles = false;
            return docConfig;
        }

        public createAvailableDocumentType(
            docConfig: Wars.Domain.Model.Documents.DocumentConfiguration,
            systemCode: Wars.Domain.Model.Codes.SystemCode): Wars.Domain.Model.Documents.DocumentTypeAvailability {
            var documentTypeAvailability = this.createNewEntity<Wars.Domain.Model.Documents.DocumentTypeAvailability>("DocumentTypeAvailability");
            documentTypeAvailability.myDocumentConfiguration = docConfig;
            documentTypeAvailability.documentConfiguration_id = docConfig.id;
            documentTypeAvailability.mySystemCode = systemCode;
            documentTypeAvailability.systemCode_id = systemCode.id;
            documentTypeAvailability.isAvailable = false;
            return documentTypeAvailability;
        }

        public getFaClass(fileName): string {
            if (!fileName) return 'fa-file-o';

            var imageExtensions = ['.jpg', '.jpeg', '.jfif', '.exif', '.tiff', '.tif', '.gif', '.bmp', '.png'];
            var wordExtensioins = ['.doc', '.dot', '.docx', '.docm', '.dotx', '.dotm', '.docb'];
            var excelExtensions = ['.xls', '.xlt', '.xlm', '.xlsx', '.xlsm', '.xltx', '.xltm'];
            var archiveExtensions = ['.zip', '.tar', '.7z'];
            var textExtensions = ['.txt'];

            var lowerCaseFileName = fileName.toLowerCase();

            if (lowerCaseFileName.endsWith(".pdf")) return 'fa-file-pdf-o';

            var image = Enumerable.from(imageExtensions).any(i => lowerCaseFileName.endsWith(i));
            if (image) return 'fa-file-image-o';

            var wordDoc = Enumerable.from(wordExtensioins).any(i => lowerCaseFileName.endsWith(i));
            if (wordDoc) return 'fa-file-word-o';

            var excel = Enumerable.from(excelExtensions).any(i => lowerCaseFileName.endsWith(i));
            if (excel) return 'fa-file-excel-o';

            var archive = Enumerable.from(archiveExtensions).any(i => lowerCaseFileName.endsWith(i));
            if (archive) return 'fa-file-archive-o';

            var text = Enumerable.from(textExtensions).any(i => lowerCaseFileName.endsWith(i));
            if (text) return 'fa-file-text-o';

            return 'fa-file-o';
        }

        public getFileSizeStringFilter(filesize: string) {
            return this.getFileSizeString(parseInt(filesize));
        }

        public getFileSizeString(filesize: number) {
            var kb = 1024;
            var mb = 1048576;
            if (!filesize) return "unknown";
            if (filesize < kb) return filesize + " bytes";
            if (filesize < mb) return Math.floor(filesize / kb) + " KB";
            return Math.floor(filesize / mb) + " MB";
        }
    }
}

warsApp.registerService("DocumentService", ["breeze", "$q", "$http", "systemLevelService"]);